<template>
  <div class="pb-16">
    <p class="px-4 mb-0 mt-4">
      <span class="font-danjunghae accent--text font-weight-medium" style="font-size: 30px" :lang="lang">
        {{ title }}
      </span>

      <span class="ml-2 text-body-1 text-md-h6" style="color: rgb(141, 141, 141); font-weight: 300 !important">
        {{ dayjs(new Date(created)).format("YYYY.M-D / HH:mm") }}
      </span>
    </p>

    <v-divider class="mx-4"></v-divider>

    <v-sheet class="py-2 px-4" style="margin-bottom: 180px">
      <v-row no-gutters>
        <v-col v-for="item in list" :key="item.imageUrl" cols="4" style="border: 1px solid white; cursor: pointer">
          <v-img width="100%" :style="selected_list.includes(item) ? 'filter: opacity(0.8);' : ''" :src="item.thumbanilUrl" @click="openDetail(item)">
            <div v-if="!item.requested">
              <v-btn
                v-if="selected_list.includes(item)"
                style="height: 24px; width: 24px; position: absolute; right: 8px; bottom: 8px"
                class="pa-0"
                fab
                x-small
                :disabled="item.requested"
                @click.stop="selectItem(item)"
              >
                <v-icon size="24" color="success">mdi-check-circle</v-icon>
              </v-btn>
              <v-btn
                v-if="!selected_list.includes(item)"
                style="height: 24px; width: 24px; position: absolute; right: 8px; bottom: 8px"
                class="pa-0"
                fab
                x-small
                :disabled="item.requested"
                @click.stop="selectItem(item)"
              >
                <v-icon size="24" color="#aaa">mdi-check-circle</v-icon>
              </v-btn>
            </div>
            <div v-if="item.requested" class="d-flex justify-center align-end px-1 py-1 sela-bottom-caption">{{ $t("page.picSelect.request-complete") }}</div>
          </v-img>
        </v-col>
      </v-row>
    </v-sheet>

    <div style="position: fixed; bottom: 0px; padding-bottom: 20px; width: 100%; max-width: 580px; background: white">
      <v-divider class="mt-2 mb-3 mx-4"></v-divider>

      <p class="px-4 mb-1 mt-2 text-center">
        <span class="text-body-2 text-md-body-2" style="color: rgb(83, 83, 83)"> {{ $t("page.picSelect.bottom-guide-text") }} </span>
      </p>

      <div class="d-flex justify-center">
        <p class="text-center mt-2" style="line-height: 16px; color: rgb(83, 83, 83)">
          <span
            >{{ $t("page.picSelect.curr-pic-count-prefix") }}<strong style="font-size: 24px; margin-left: 4px">{{ selected_list.length }}</strong>
            {{ $t("page.picSelect.curr-pic-count-suffix") }}</span
          ><br />
          <span class="grey--text text--darken-1" style="font-size: 12px"> {{ $t("page.picSelect.bottom-count-text-guide", { count: freeTicketCount + 1 }) }} </span>
        </p>

        <p>
          <span class="primary--text font-danjunghae ml-6" style="font-size: 34px">
            {{ $toComma(computed_total_price) }}
          </span>
          <span class="text-body-1" style="color: rgb(83, 83, 83) !important"> {{ $t("common.krw") }} </span>
        </p>
      </div>

      <div class="d-flex justify-center mb-6">
        <v-btn width="34%" large text color="rgb(84, 84, 84)" style="border: 2px solid #e9e9e9; font-size: 22px" class="rounded-md font-weight-medium" to="/mypage/home">
          {{ $t("button.go-back") }}
        </v-btn>

        <v-btn
          width="34%"
          large
          text
          color="grey"
          style="border: 2px solid #e9e9e9; background-color: #d9bddd; color: #66546d !important; font-size: 22px"
          class="ml-3 rounded-md font-weight-medium"
          @click="checkSubmit()"
          :disabled="selected_list.length == 0"
          :loading="pay_loading"
        >
          {{ $t("button.select-complete") }}
        </v-btn>
      </div>
    </div>

    <!-- 확대 -->
    <v-dialog v-model="dialog.detail" activator="parent" content-class="sela-dialog">
      <div class="sela-dialog-card" style="height: 85% !important">
        <DialogHeaderWithButtons @close="dialog.detail = false">
          <template #center-buttons>
            <IconButton :icon-src="require('@/assets/buttons/download_ic.png')" :text="$t('button.save')" @click="openUrlForDownload(selected_item)" />
            <IconButton
              :icon-src="require('@/assets/buttons/select_ic.png')"
              :text="selected_list.includes(selected_item) ? $t('button.deselect') : $t('button.select')"
              @click="selectItem(selected_item)"
            />
          </template>
        </DialogHeaderWithButtons>
        <v-img class="sela-dialog-card-content position-relative" :src="selected_item.imageUrl" :lazy-src="selected_item.thumbanilUrl" :key="selected_item.imageUrl" contain>
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular color="white" indeterminate></v-progress-circular>
            </div>
          </template>

          <!-- 이전 사진 버튼 -->
          <v-btn v-if="hasPreviousImage" @click="goToPreviousImage" fab small class="nav-button nav-button-left" color="rgba(0, 0, 0, 0.6)" elevation="3">
            <v-icon color="white" size="32">mdi-chevron-left</v-icon>
          </v-btn>

          <!-- 다음 사진 버튼 -->
          <v-btn v-if="hasNextImage" @click="goToNextImage" fab small class="nav-button nav-button-right" color="rgba(0, 0, 0, 0.6)" elevation="3">
            <v-icon color="white" size="32">mdi-chevron-right</v-icon>
          </v-btn>

          <!-- 체크박스 아이콘 -->
          <v-icon class="checkbox-icon" size="24" :color="selected_list.includes(selected_item) ? 'success' : '#aaa'" @click="selectItem(selected_item)"> mdi-check-circle </v-icon>
        </v-img>
        <!-- 상단 아이콘 버튼으로 변경 -->
        <!--
        <div class="px-2 mt-2">
          <PanelButton @click="dialog.filter = true" :title="$t('dialog.edit-bg')" :message="$t('dialog.edit-bg-guide')" />
          <ShotFilterDialog v-if="dialog.filter" :item="selected_item" :visible="dialog.filter" @close="dialog.filter = false" />
        </div>
        
        <div class="sela-dialog-card-footer relative">
          <v-btn outlined class="sela deactivate largeText" @click="share(selected_item)" width="49%">{{ $t("button.ask-friend") }}</v-btn>
          <v-btn
            v-if="!selected_list.includes(selected_item)"
            :disabled="selected_item?.requested"
            outlined
            class="sela largeText"
            @click="
              selectItem(selected_item)
              dialog.detail = false
            "
            width="49%"
          >
            {{ $t("button.select") }}
          </v-btn>
          <v-btn v-if="selected_list.includes(selected_item)" :disabled="selected_item?.requested" outlined class="sela largeText" @click="selectItem(selected_item)" width="28%">{{
            $t("button.deselect")
          }}</v-btn>
        </div>
        -->
      </div>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex"
import DialogHeaderWithButtons from "@/views/components/DialogHeaderWithButtons"
import IconButton from "@/views/components/IconButton"
import PanelButton from "@/views/components/PanelButton"
import ShotFilterDialog from "./ShotFilterDialog.vue"
import payletterService from "@/api/payletter-service"

export default {
  components: {
    DialogHeaderWithButtons,
    IconButton,
    PanelButton,
    ShotFilterDialog,
  },

  data: () => ({
    title: "",
    qrcode: "",
    created: null,
    list: [],

    orderItem: null, //주문 상품.

    selected_item: "",

    selected_list: [],

    dialog: {
      detail: false,
      alert: false,
      filter: false,
    },

    // 토스페이먼츠
    tossPayments: null,

    imageHost: process.env.NODE_ENV == "development" ? "https://lafia-studio.com" : "",

    pay_loading: false,
  }),

  computed: {
    ...mapState(["lang", "lafia_user", "isSupportAbroadPay"]),
    ...mapGetters(["isKRW"]),

    // 현재 선택된 사진의 인덱스
    currentImageIndex() {
      return this.list.findIndex((item) => item === this.selected_item)
    },

    // 이전 사진 존재 여부
    hasPreviousImage() {
      return this.currentImageIndex > 0
    },

    // 다음 사진 존재 여부
    hasNextImage() {
      return this.currentImageIndex < this.list.length - 1
    },

    // 최종 가격 계산
    computed_total_price() {
      const requestedCount = this.list.filter((x) => x.requested)
      const freeCount = Math.max(this.freeTicketCount - requestedCount.length, 0)
      return Math.max((this.selected_list.length - freeCount) * 3900, 0)
    },
    // 주문 갯수
    orderCount() {
      const requestedCount = this.list.filter((x) => x.requested)
      const freeCount = Math.max(this.freeTicketCount - requestedCount.length, 0)
      return Math.max(this.selected_list.length - freeCount, 0)
    },

    freeTicketCount() {
      if (this.orderItem) {
        // memo가 JSON 형식인지 확인
        try {
          const memoObj = JSON.parse(this.orderItem.memo)
          if (memoObj && memoObj.freePicEditCount !== undefined) {
            return memoObj.freePicEditCount
          }           
        } catch (e) {
          // JSON 파싱 실패 시 기존 방식으로 처리
        }

        // 기존 방식 (문자열 ID)
        switch (this.orderItem.memo) {
          case "option4":
            return 3
          case "option5":
            return 4
          case "option6":
            return 5
          default:
            return 1
        }
      } else {
        return 1
      }
    },
  },

  mounted() {
    if (!this.lafia_user.is_logined) {
      alert("로그인 후 이용가능합니다.")
      let loginPath = "/auth/login"
      this.$router.push(loginPath)
      return
    }

    // payletter 관련 프로퍼티 초기화 (반응형 시스템 외부에서 관리)
    this.payletterWindow = null
    this.payletterWindowEventListener = null

    this.load()
    // 토스 기본설정
    this.tossInit()
  },

  methods: {
    ...mapActions(["cancelPayStatusUpdate"]),
    // 토스 기본설정
    tossInit() {
      let recaptchaScript = document.createElement("script")
      recaptchaScript.setAttribute("src", "https://js.tosspayments.com/v1")
      document.head.appendChild(recaptchaScript)
    },

    load() {
      this.$http
        .post("/api/qrcode/select/byId", {
          params: {
            id: this.$route.query.id,
          },
        })
        .then((res) => {
          this.title = this.getTitle(res.data[0])

          this.qrcode = res.data[0].qrcode
          this.created = res.data[0].created
          const selected_filenames = res.data[0].selected_filenames.split(",")
          this.list = res.data[0].filenames.split(",").map((x) => {
            return {
              title: res.data[0].title,
              filename: x,
              thumbanilUrl: this.$qrcodeResizedImageUrl(this.qrcode, x),
              imageUrl: this.$qrcodeImageUrl(this.qrcode, x),
              requested: selected_filenames.indexOf(x) > -1,
            }
          })
          const reservation_id = res.data[0].reservation_id
          this.$http
            .post("/api/order/select/byReservation", {
              params: {
                reservation_id: reservation_id,
              },
            })
            .then((res) => {
              const orderItem = res.data[0]
              if (orderItem && orderItem.status === "결제완료") {
                this.orderItem = orderItem
              } else {
                this.orderItem = null
              }
            })
        })
    },

    openDetail(item) {
      this.selected_item = item
      this.dialog.detail = true
    },

    // 이전 사진으로 이동
    goToPreviousImage() {
      if (this.hasPreviousImage) {
        this.selected_item = this.list[this.currentImageIndex - 1]
      }
    },

    // 다음 사진으로 이동
    goToNextImage() {
      if (this.hasNextImage) {
        this.selected_item = this.list[this.currentImageIndex + 1]
      }
    },

    download(item) {
      const a = document.createElement("a")
      a.href = item.imageUrl
      a.download = item.filename
      a.click()
      //window.open(item.imageUrl, "_blank")
    },

    openUrlForDownload(item) {
      //console.log(item)
      window.open("https://front.lafia-studio.com/imageViewer-qrcode-v1.html?image=" + item.filename + "&qrcode=" + this.qrcode, "_blank")
    },

    async share(item) {
      await this.$shareLink(item.imageUrl)
    },

    selectItem(item) {
      if (item.requested) {
        return
      }
      if (this.selected_list.includes(item)) {
        this.selected_list = this.selected_list.filter((x) => x !== item)
      } else {
        this.selected_list.push(item)
      }
    },

    checkSubmit() {
      if (this.selected_list.length == 0) {
        alert("사진을 선택해주세요.")
        return
      }

      // payletter 팝업 미리 생성 (팝업 차단 방지)
      if (this.isSupportAbroadPay && !this.isKRW) {
        var popOption = "width=430, height=555, resizable=no, scrollbars=no, status=no;"
        var popGlOption = "width=800, height=600, resizable=no, scrollbars=no, status=no;"
        if (this.$vuetify.breakpoint.mobile) {
          this.payletterWindow = window.open("about:blank", "_blank", popOption)
        } else {
          this.payletterWindow = window.open("about:blank", "_blank", popGlOption)
        }

        if (!this.payletterWindow || this.payletterWindow.closed || typeof this.payletterWindow.closed == "undefined") {
          alert(this.$t("alert.error_popup_blocked"))
          return
        }
      }

      this.submit()
    },

    submit: _.debounce(async function () {
      if (!this.lafia_user.is_logined) {
        alert("로그인 후 이용가능합니다.")
        let loginPath = "/auth/login"
        this.$router.push(loginPath)
        return
      }

      let orderId = Math.floor(Math.random() * 1000000000)

      if (this.pay_loading) {
        alert(this.$t("alert.error_doing_pay_in_progress"))
        return
      }

      try {
        this.pay_loading = true

        const orderRes = await this.$http.post("/api/order/v2/order", {
          orderId: orderId.toString(),
          userId: this.$store.state.lafia_user.user_id,
          orderDetailList: [
            {
              productName: "온라인추가보정신청",
              orderNum: this.orderCount,
              price: 3900,
              totalPrice: this.computed_total_price,
              finalPrice: this.computed_total_price,
            },
          ],
          memo: "무인촬영기",
          type: "온라인추가보정신청",
        })

        // 선택한 사진 입력하기
        await this.$http.post("/api/qrcode/update/selected_filenames", {
          params: {
            id: this.$route.query.id,
            order_id: orderRes.data.id,
            selected_filenames: this.selected_list.map((x) => x.filename).toString(),
          },
        })

        if (this.computed_total_price > 0) {
          // 모든 작업이 완료된 후 토스 결제
          if (process.env.VUE_APP_TOSS_TEST_PAYMENT === "true" && window.confirm("테스트 결제 하기")) {
            this.$router.replace("/toss/success?orderId=" + orderId + "&paymentKey=test&amount=" + this.computed_total_price)
          } else {
            let orderName = this.title + " " + this.selected_list.length + "개 사진 선택"
            if (this.isSupportAbroadPay && !this.isKRW) {
              if (this.payletterWindow) {
                const { online_url, mobile_url } = await payletterService.requestInternationalPay({
                  storeorderno: orderId.toString(),
                  amount: this.computed_total_price,
                  currency: "KRW",
                  payinfo: orderName,
                  payeremail: this.lafia_user.email,
                  payerid: this.lafia_user.user_id,
                })
                if (this.$vuetify.breakpoint.mobile) {
                  this.payletterWindow.location.href = mobile_url
                } else {
                  this.payletterWindow.location.href = online_url
                }
              }

              if (this.payletterWindow) {
                this.payletterWindowEventListener = async (event) => {
                  if (event.data.message === "pay-completed") {
                    const payloadData = event.data.data
                    this.payletterEventUnregister()
                    const { retCode, orderNo, status } = payloadData
                    if (retCode == "0") {
                      // 성공
                      this.$router.push("/payletter/success?orderId=" + orderId + "&amount=" + this.computed_total_price)
                    } else {
                      // 실패
                      this.$router.push("/fail?orderId=" + orderId + "&message=" + status)
                    }
                  }
                }
                window.addEventListener("message", this.payletterWindowEventListener)
              }
            } else {
              var tossPayments = TossPayments(process.env.VUE_APP_TOSS_PAYMENT_CLIENT_KEY)
              try {
                await tossPayments.requestPayment("카드", {
                  amount: this.computed_total_price,
                  orderId: orderId,
                  orderName,
                  customerName: this.lafia_user.name,
                  customerEmail: this.lafia_user.email,
                  successUrl: window.location.origin + "/toss/success",
                  failUrl: window.location.origin + "/fail",
                  useEscrow: false,
                })
              } catch (e) {
                console.error("토스페이먼츠 결제", error)
                this.cancelPayStatusUpdate({ order_id: orderRes.data.id, reason: "사용자취소" })
              }
            }
          }
        } else {
          const picSelectRes = await this.$http.post("/api/qrcode/update/status/andSelected", {
            params: {
              id: this.$route.query.id,
              status: "선택완료",
              qrcode: this.qrcode,
              paymentKey: process.env.VUE_APP_TOSS_TEST_PAYMENT === "true" ? "test" : "free",
            },
          })
          console.log(picSelectRes)

          const result = await this.$http.post("/api/order/update/status", {
            params: {
              id: orderRes.data.id,
              status: "결제완료",
            },
          })
          if (result.data.affectedRows) {
            alert(this.$t("alert.succes_to_compl_select_picture"))
            this.$router.push("/mypage/home?type=picture")
          } else {
            alert(this.$t("alert.error_to_failed_select_picture"))
          }
        }
      } catch (e) {
        console.log(e)
        alert(this.$t("alert.error_doing_pay_unknown_error_2"))
      } finally {
        this.pay_loading = false
      }
    }, 500),

    payletterEventUnregister() {
      console.log("payletterEventUnregister")
      if (this.payletterWindowEventListener) {
        window.removeEventListener("message", this.payletterWindowEventListener)
      }
      this.payletterWindowEventListener = null
      this.payletterWindow = null
    },

    getTitle(item) {
      switch (this.lang) {
        case "en":
          return item.title_en || item.title
        case "jp":
          return item.title_jp || item.title
        default:
          return item.title
      }
    },
  },
  beforeDestroy() {
    this.payletterEventUnregister()
  },
}
</script>
<style scoped>
::v-deep .v-divider {
  border-width: medium 0 0 0;
}

.nav-button {
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10 !important;
}

.nav-button-left {
  left: 16px !important;
}

.nav-button-right {
  right: 16px !important;
}

.checkbox-icon {
  position: absolute !important;
  top: 8px !important;
  left: 8px !important;
  z-index: 10 !important;
  cursor: pointer !important;
}
</style>
